var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 118.7 118.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f18023",
    d: "M100 50.5h18.7a49.4 49.4 0 0 0-88.5-21.2A46.1 46.1 0 0 1 100 50.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb811",
    d: "M77 65.2v14.6h17.2a58.7 58.7 0 0 1-24.1 18.7c-6.3 2-12.9 2.2-12.9 2.2h-2a50 50 0 0 1-39.9-79.9 58.4 58.4 0 1 0 88.8 75.8v12.5h14.4V65.2H77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f49f1f",
    d: "M18.8 51.9A48 48 0 0 1 82.3 6.5 48 48 0 0 0 10 48.2a48.3 48.3 0 0 0 33.7 46 48.7 48.7 0 0 1-24.9-42.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.8bdab5a5bb75c87f51df7cfffee5e68c.svg";
export { ForwardRef as ReactComponent };